import { FC } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { IconCheckCircle } from "src/components/Icons/Icons";

interface IProps {
  assignmentId: number;
  onViewAssignment: () => void;
  onCreateAnother: () => void;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 40px 32px;
  max-width: 440px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
`;

const SuccessIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #d4edda;
  color: #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #212529;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 28px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const PublishSuccessModal: FC<IProps> = ({ assignmentId, onViewAssignment, onCreateAnother }) => {
  const [t] = useTranslation();

  return (
    <Overlay>
      <ModalBox>
        <SuccessIcon>
          <IconCheckCircle size={32} />
        </SuccessIcon>
        <Title>{t("assignment_published_success", "Assignment published successfully!")}</Title>
        <Subtitle>
          {t("assignment_published_summary", "Assignment #{{id}} is now live and visible to students.", {
            id: assignmentId
          })}
        </Subtitle>
        <ButtonRow>
          <button className="btn btn-edit" onClick={onViewAssignment}>
            {t("assignment_view", "View Assignment")}
          </button>
          <button className="btn custom_primary_btn" onClick={onCreateAnother}>
            {t("assignment_create_another", "Create Another")}
          </button>
        </ButtonRow>
      </ModalBox>
    </Overlay>
  );
};

export default PublishSuccessModal;
